import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router
  ) { }

  // Get user session
  async getSession() {
    
     const token = localStorage.getItem('token')

    return token;
    // return session;
  }

  // Sign in
  async signIn(email: string, password: string) {

    // Sample only - remove this after real authentication / session
    let sample_user = {
      email: email,
      password: password
    }

    return sample_user;
  }

  // Sign up
  async signUp(email: string, password: string) {

    // Sample only - remove this after real authentication / session
    let sample_user = {
      email: email,
      password: password
    }

    return sample_user;
  }

  // Sign out
  async signOut() {

    // ...
    // clean subscriptions / local storage etc. here
    localStorage.clear();
    sessionStorage.clear();
    // ...

    // Navigate to sign-in
    this.router.navigateByUrl('/signin');
     Promise.resolve().then(() => window.location.reload());
  }
}
